import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { productCodeToExplorerLayerIdMappings } from "pages/geoscape-data/constants";
import { useHistory } from "react-router-dom";
import { viewDatasetInExplorer } from "../explorer-navigation";

interface CatalogueEntryCoverageProps {
  image: string;
  datasetId: string;
}

export const CatalogueEntryCoverage = ({
  image,
  datasetId,
}: CatalogueEntryCoverageProps) => {
  const history = useHistory();
  const hasExplorerLayer =
    !!productCodeToExplorerLayerIdMappings.get(datasetId);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Coverage Area</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          className={`aspect-square overflow-hidden rounded-md ${hasExplorerLayer ? "cursor-pointer" : ""}`}
          onClick={
            hasExplorerLayer
              ? () => viewDatasetInExplorer(datasetId, history)
              : undefined
          }
        >
          <img
            src={image}
            alt="Dataset coverage area"
            className="h-full w-full object-cover"
          />
        </div>
      </CardContent>
    </Card>
  );
};
